import * as React from 'react';
import Image from "next/image";
import {
  ProcessTimelineWrapper,
  TimelineImage,
  TimelineVideo,
  Title,
} from './processTimeline.style';
import { useWindowSize } from '../../../hooks/useWindowSize';
import { ImageFieldImage } from '@prismicio/types';
import { imageSerializer } from 'utils/imageSerializer';

type ProcessTimelineProps = {
  image: ImageFieldImage;
};

export const ProcessTimeline = ({ image }: ProcessTimelineProps) => {
  const { small } = useWindowSize();
  return (
    <ProcessTimelineWrapper>
      <Title>Product Development Timeline</Title>
      {small ? (
        <TimelineVideo>
          <video autoPlay muted preload="auto">
            <source src="/videos/timeline_3.mp4" type="video/mp4" />
          </video>
        </TimelineVideo>
      ) : (
        <TimelineImage>
          <Image
            {...imageSerializer(image)}/>
        </TimelineImage>
      )}
    </ProcessTimelineWrapper>
  );
};
